module.exports = __webpack_public_path__ + "img/pic5.67778a69.png";